/* eslint-disable eqeqeq */
/* eslint-disable no-param-reassign */
/* eslint-disable react/no-find-dom-node */
import { find, findIndex, isEmpty, some } from 'lodash';
import * as queryString from 'query-string';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';

import PropTypes from 'prop-types';
import * as actions from '../../actions/club-actions';
import * as eventActions from '../../actions/event-actions';
import * as loginPopUpActions from '../../actions/login-popup-actions';
import * as messagingActions from '../../actions/messaging-actions';
import { showErrorPopup } from '../../actions/notification-actions';
import ClubProfileHeader from '../../components/Clubs/ClubProfile/ClubProfileHeader';
import EventsTabContent from '../../components/Clubs/ClubProfile/EventsTabContent';
import ScheduleTabContent from '../../components/Clubs/ClubProfile/ScheduleTabContent';
import LeaguesTabContent from '../../components/Clubs/ClubProfile/TabContents/LeaguesTabContent';
import ConnectedMembersTabContent from '../../components/Clubs/ClubProfile/TabContents/MembersTabContent';
import OverviewTabContent from '../../components/Clubs/ClubProfile/TabContents/OverviewTabContent';
import ResultsTabContent from '../../components/Clubs/ClubProfile/TabContents/ResultsTabContent';
import RosterTabContent from '../../components/Clubs/ClubProfile/TabContents/RosterTabContent';
import { ClubInactivePopup, MemberLimitPopup, OrganizerLimitPopup } from '../../components/Clubs/Popups';
import * as SplashComponents from '../../components/Clubs/Splash';
import { SortType } from '../../components/ColumnHeader';
import head from '../../components/Meta';
import InviteMembersModal from '../../components/Modals/InviteMembersModal';
import PhotoEditor from '../../components/PhotoUpload/PhotoEditor';
import {
    AddUpdatePlayerOnRosterPopUp,
    // HSOrganizerWelcomePopUp,
    CompareTeamPopUp,
    ConfirmRedshirtStatusPopUp,
    MessagePopUp,
    OrganizerWelcomePopUp,
    PaidHitAvailabilityPopup,
    RemovePlayerFromRosterPopUp,
    RemoveRedshirtStatusPopUp,
    RosterLockedPopUp,
    WelcomePopUp,
} from '../../components/PopUps';
import GenericPopup from '../../components/PopUps/GenericPopup';
import { isLoginPopUpNeeded, titles, userParams } from '../../components/PopUps/LoginPopUpWrapper/LoginPopUp/utils';
import ReferralCodePopUp from '../../components/PopUps/ReferralCodePopup';
import CollegeClubIntroPopUp from '../../components/PopUps/WelcomePopUps/CollegeClubIntroPopUp';
import TabBar from '../../components/TabBar';
import UpgradeToPerformanceHsPopUp from '../../components/Upgrade/UpgradeToPerformanceHs/UpgradeToPerformanceHsPopUp';
import UpgradeToPowerPopUp from '../../components/Upgrade/UpgradeToPowerPopUp';
import { SUBSCRIPTIONS_PATH } from '../../components/hooks/useStartPowerCheckout';
import UpgradeToProClubPopUp from '../../components/Upgrade/UpgradeToProClubPopUp';
import LearnMoreUtrCollegePopUp from '../../components/Upgrade/UpgradeToUtrCollege/LearnMoreUtrCollegePopUp';
import withStatsig from '../../components/hocs/withStatsig';
import { removeQueryParam } from '../../utils';
import { formatLockEndDate } from '../../utils/formatting';
import {
    ClubTierTypes,
    getClubNameDisplay,
    isActive,
    isClubAdminOrOwner,
    // suspended,
    isClubMember,
    isClubOwner,
    isCoachClub,
    isCollegeClub,
    isPersonalClub,
    isTournamentClub,
    paymentRequired,
} from '../../utils/clubs';
import { userIsFreeCollegeClubOwner, userIsPaidHitter, userIsProCollegeAdminOrClubOwner } from '../../utils/user';

import { fetchPaidHitClubPaymentAccounts, validateReferral } from '../../actions';
import { setPlayerId } from '../../actions/profile-actions';
import { clearTempPhoto, uploadTempPhoto } from '../../actions/upload-actions';
import { postComponentAction } from '../../api/componentConfigApi';
import * as rostersApi from '../../api/rostersApi';
import { requestPaidHitForPlayer } from '../../api/tmsEventsApi';

import { CLASS_YEAR_IDS, ClubProfileTabIdentifiers, getClassYearIdFromStatus, mapClassYearIdForRedshirt, mapClassYearIdToDropdown } from '../../utils/constants';
import { EventScheduleTypes } from '../../utils/eventConstants';
import { getApiAxiosInstance, getRostersApiAxiosInstance } from '../../utils/network';
import { getHSClaimReferralUrl, getReferralUrl, parseReferralCode } from '../../utils/referrals';
import { collegeCornerSegmentTitles } from './constants';

import config from '../../../config';

import styles from './club.scss';

const _ = { findIndex, isEmpty, find, some };
const college = 'College';

const renderCollegeCornerTabTitle = () => (
    <div className={`${styles.CollegeCornerTabText} link`}>
        <span data-testid="club-profile.college-corner-tab.label">College corner</span>
        <img src="/img/arrow-right.svg" data-testid="club-profile.college-corner-tab.arrow-icon" />
    </div>
);

class ClubProfilePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showPhotoEditor: false,
            photoEditorType: 'club_banner',
            showClubReferralCodePopup: false,
            showPowerPopup: false,
            showProClubPopup: false,
            showPaidHitAvailabilityPopup: false,
            showPaidHitPopupMessage: false,
            isSendingPaidHitRequest: false,
            powerPopupType: null,
            handlePowerSuccess: null,
            showMemberLimitPopup: false,
            showOrganizerLimitPopup: false,
            showInactivePopup: false,
            adminSplash: null,
            showAdminSplash: false,
            showInviteMembersModal: false,
            tabs: [
                {
                    id: ClubProfileTabIdentifiers.OVERVIEW,
                    title: 'Overview',
                    needsLogin: false,
                    showTab: true,
                    sortPosition: ClubProfileTabIdentifiers.OVERVIEW,
                },
                {
                    id: ClubProfileTabIdentifiers.ROSTER,
                    title: 'Roster',
                    needsLogin: true,
                    showTab: true,
                    sortPosition: ClubProfileTabIdentifiers.ROSTER,
                },
                {
                    id: ClubProfileTabIdentifiers.SCHEDULE,
                    title: 'Schedule',
                    needsLogin: true,
                    showTab: true,
                    sortPosition: ClubProfileTabIdentifiers.SCHEDULE,
                },
                {
                    id: ClubProfileTabIdentifiers.EVENTS,
                    title: 'Events',
                    needsLogin: true,
                    showTab: true,
                    sortPosition: ClubProfileTabIdentifiers.EVENTS,
                },
                {
                    id: ClubProfileTabIdentifiers.LEAGUES,
                    title: 'Team Leagues',
                    needsLogin: false,
                    showTab: this.props.showLeaguesTab,
                    sortPosition: ClubProfileTabIdentifiers.LEAGUES,
                },
                {
                    id: ClubProfileTabIdentifiers.RESULTS,
                    title: 'Results',
                    needsLogin: true,
                    showTab: true,
                    sortPosition: ClubProfileTabIdentifiers.RESULTS,
                },
                {
                    id: ClubProfileTabIdentifiers.MEMBERS,
                    title: 'Members',
                    needsLogin: true,
                    showTab: true,
                    sortPosition: ClubProfileTabIdentifiers.MEMBERS,
                },
                {
                    id: ClubProfileTabIdentifiers.COLLEGE_CORNER,
                    title: renderCollegeCornerTabTitle,
                    needsLogin: true,
                    showTab: true,
                    newSegment: true,
                    isURL: true,
                    onClickURL: () => {
                        this.props.history.push(
                            `/college-corner`,
                        );
                    },
                    sortPosition: ClubProfileTabIdentifiers.COLLEGE_CORNER,
                },
            ],
            eventsTabState: {
                eventsType: EventScheduleTypes.UPCOMING,
            },
            redirect: false,
            redirectUrl: '/',
            membersTabState: {
                adminViewType: 'members',
                memberViewType: 'current',
                requestViewType: 'Pending',
                inviteViewType: 'pending',
            },
            rosterTabState: {
                rosterSortParam: 'singlesRating',
                rosterSortType: SortType.DESC,
                showUpdatePlayerPopUp: false,
                updatePlayerOnRosterPlayerId: null,
                updatePlayerOnRosterPlayerName: null,
                showRemovePlayerConfirmationPopUp: false,
                removePlayerFromRosterPlayerId: null,
                removePlayerFromRosterPlayerName: null,
                showAddPlayerToRosterPopUp: false,
                showCompareTeamPopUp: false,
                showRedshirtConfirmationPopUp: false,
                redshirtPlayerId: null,
                redshirtPlayerName: null,
                showRemoveRedshirtConfirmationPopUp: false,
                removeRedshirtPlayerId: null,
                removeRedshirtPlayerName: null,
                showRosterLockedPopUp: false,
            },
            power6Data: null,
            actionPerformed: false,
            showLearnMoreUtrCollegePopup: false,
            showUpgradeToPerformanceHsPopup: false,
            showUtrCollegeIntroPopup: true,
            message: {
                showModal: false,
            },
        };
        this.handleTabClick = this.handleTabClick.bind(this);
        this.createEvent = this.createEvent.bind(this);
        this.inviteMembers = this.inviteMembers.bind(this);
        this.onInvitePlayersClick = this.onInvitePlayersClick.bind(this);
        this.closeInviteMembersModal = this.closeInviteMembersModal.bind(this);
        this.showAdminSplash = this.showAdminSplash.bind(this);
        this.handleCropPhoto = this.handleCropPhoto.bind(this);
        this.handleHidePhotoEditor = this.handleHidePhotoEditor.bind(this);
        this.handleUploadPhotoStart = this.handleUploadPhotoStart.bind(this);
        this.handleUploadPhoto = this.handleUploadPhoto.bind(this);
        this.handleSuccessReload = this.handleSuccessReload.bind(this);
        this.handlePowerSuccessForPayment = this.handlePowerSuccessForPayment.bind(this);
        this.handleUploadLogoStart = this.handleUploadLogoStart.bind(this);
        this.handleCropSponsorLogo = this.handleCropSponsorLogo.bind(this);
        this.approveOrRejectRequest = this.approveOrRejectRequest.bind(this);
        this.handleRequestToJoinClick = this.handleRequestToJoinClick.bind(this);
        this.showUpgradeToProClubCollegePopup = this.showUpgradeToProClubCollegePopup.bind(this);
        this.handleUploadClubProfilePhotoStart = this.handleUploadClubProfilePhotoStart.bind(this);
        this.handleCropClubProfilePhoto = this.handleCropClubProfilePhoto.bind(this);
        this.showLearnMoreUtrCollegePopup = this.showLearnMoreUtrCollegePopup.bind(this);
        this.showUpgradeToPerformanceHsPopup = this.showUpgradeToPerformanceHsPopup.bind(this);
        this.handlePerformanceHsPopupCloseClick = this.handlePerformanceHsPopupCloseClick.bind(this);
        this.handlePerformanceHsPopupUpgradeClick = this.handlePerformanceHsPopupUpgradeClick.bind(this);
        this.getCurrentClubAsOptionToUpgrade = this.getCurrentClubAsOptionToUpgrade.bind(this);
        this.sendMessage = this.sendMessage.bind(this);
        this.setTabBarRef = this.setTabBarRef.bind(this);
        this.onSelected = this.onSelected.bind(this);
        this.onCreateEventClick = this.onCreateEventClick.bind(this);
        this.onShowAllEventsClick = this.onShowAllEventsClick.bind(this);
        this.openPendingRequests = this.openPendingRequests.bind(this);
        this.showOrganizerLimitPopup = this.showOrganizerLimitPopup.bind(this);
        this.closePlayerGroupWelcomePopup = this.closePlayerGroupWelcomePopup.bind(this);
        this.handleShowLoginPopUp = this.handleShowLoginPopUp.bind(this);
        this.getReferralPopupSetttings = this.getReferralPopupSetttings.bind(this);
        this.showMessagePopUp = this.showMessagePopUp.bind(this);
        this.closeMessagePopUp = this.closeMessagePopUp.bind(this);
        this.exportMembers = this.exportMembers.bind(this);
        this.onTeamMatchMenuSelected = this.onTeamMatchMenuSelected.bind(this);
        this.handleOnRequestPaidHit = this.handleOnRequestPaidHit.bind(this);
        this.handleRequestPaidHitSubmit = this.handleRequestPaidHitSubmit.bind(this);
        this.handleOnRequestClosePaidHitPopup = this.handleOnRequestClosePaidHitPopup.bind(this);
        this.handleOnCloseClick = this.handleOnCloseClick.bind(this);
        this.handleRosterLockedPopUpCloseClick = this.handleRosterLockedPopUpCloseClick.bind(this);
        this.handleCloseCompareTeamPopUp = this.handleCloseCompareTeamPopUp.bind(this);
        this.handleCloseAddPlayerToRosterPopUp = this.handleCloseAddPlayerToRosterPopUp.bind(this);
        this.handleCloseRemovePlayerConfirmationPopUp = this.handleCloseRemovePlayerConfirmationPopUp.bind(this);
        this.handleRedshirtCloseClick = this.handleRedshirtCloseClick.bind(this);
        this.handleRemoveRedshirtCloseClick = this.handleRemoveRedshirtCloseClick.bind(this);
        this.renderUpdatePlayerPopUp = this.renderUpdatePlayerPopUp.bind(this);
        this.renderRedshirtConfirmationPopUp = this.renderRedshirtConfirmationPopUp.bind(this);
        this.renderRemoveRedshirtConfirmationPopUp = this.renderRemoveRedshirtConfirmationPopUp.bind(this);

        // asyncronously validate referral if exists
        const referralCode = parseReferralCode(this.props.location.search);
        if (referralCode) {
            this.props.validateReferral(referralCode);
        }
        this.showUpgradeToPowerPopup = this.showUpgradeToPowerPopup.bind(this);
    }

    componentDidMount() {
        const parsed = queryString.parse(this.props.location.search);
        if (parsed.member) {
            this.showAdminSplash(<SplashComponents.YouAreMember />, 3000);
        } else if (this.props.club.isClubCreated) {
            this.showAdminSplash(<SplashComponents.ClubCreated />, 3000);
        } else if (this.props.club.isClubUpdated) {
            this.showAdminSplash(<SplashComponents.ClubUpdated />, 3000);
        } else if (this.props.club.membersInvited) {
            this.showAdminSplash(<SplashComponents.MembersInvited />, 3000);
        } else if (this.props.club.addedAdmins) {
            this.showAdminSplash(<SplashComponents.AdminsAdded />, 3000);
        }

        this.props.clearSplashProps();
        if (parsed.welcome) {
            this.setState({ showOrganizerWelcomeScreen: true });
        }
        const { club: { clubDetails = {}, schoolDetailsState = {} } = {}, auth: { user: UserLoggedIn = {} } = {} } = this.props;
        const collegeDualMatchFlagEnabled = this.props.checkGate(this.props.featureGates.COLLEGE_DUAL_MATCH);
        const isRostersRolloutEnabled = this.props.checkGate && this.props.featureGates
            ? this.props.checkGate(this.props.featureGates.ROSTERS_ROLLOUT)
            : false;

        const tabIdentifier = parsed.t || ClubProfileTabIdentifiers.OVERVIEW;
        const selectedTab = _.find(this.state.tabs, { id: tabIdentifier });

        const clubTierType = (clubDetails?.tierType) || {};
        // chcek if tab needs login
        if (selectedTab?.needsLogin && clubTierType.isCollege && (!UserLoggedIn || !collegeDualMatchFlagEnabled)) {
            this.props.history.push({
                search: `?t=${ClubProfileTabIdentifiers.OVERVIEW}`,
            });
        }

        // Fetch school details if club has school and details haven't been fetched yet
        // Only fetch for logged-in users
        if (UserLoggedIn &&
            clubDetails?.clubHasSchool &&
            clubDetails?.id &&
            schoolDetailsState?.complete !== true) {
            this.props.getClubSchoolDetails(isRostersRolloutEnabled);
        }

        // Fetch Power 6 data from rosters-api
        this.fetchPower6FromRostersApi();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { clubDetails, schoolDetails, schoolDetailsState } = nextProps.club;
        const userLoggedIn = nextProps.auth?.user;
        const isMember = isClubMember(clubDetails);
        const showPrivateContent = (clubDetails && !clubDetails.private) || isMember;
        const clubTierType = clubDetails?.tierType || {};
        const canPostScores = !_.isEmpty(clubTierType) ? clubTierType.canPostScores : false;
        const newLogin = this.props.auth && nextProps.auth && this.props.auth.user !== nextProps.auth.user;
        const isRostersRolloutEnabled = nextProps.checkGate && nextProps.featureGates
            ? nextProps.checkGate(nextProps.featureGates.ROSTERS_ROLLOUT)
            : false;
        const prevClubDetails = this.props.club?.clubDetails;

        if (!this.props.club.isLoading && !nextProps.club.isLoading && (nextProps.match.params.clubId !== this.props.club.clubId || newLogin)) {
            this.props.setClubId(nextProps.match.params.clubId);
        } else {
            // Check if we should fetch school details when club details first load
            // Only fetch for logged-in users
            if (userLoggedIn &&
                clubDetails?.clubHasSchool &&
                clubDetails?.id &&
                (!prevClubDetails?.id || prevClubDetails?.id !== clubDetails?.id) &&
                !nextProps.club.isLoading &&
                schoolDetailsState?.complete !== true) {
                this.props.getClubSchoolDetails(isRostersRolloutEnabled);
            }
            // show admin splash to owner if club is suspended, revoked, or pending
            if (clubDetails?.statusType && !this.state.showAdminSplash) {
                const isOwner = isClubOwner(clubDetails);

                if (isOwner && !isActive(clubDetails)) {
                    this.showAdminSplash(<SplashComponents.Inactive
                        status={clubDetails.statusType.value}
                        clubTierType={clubDetails.tierType}

                    />);
                }
                if (isOwner && paymentRequired(clubDetails)) {
                    this.showAdminSplash(<SplashComponents.PaymentRequired clubTierType={clubDetails.tierType} onClick={() => this.setState({ showProClubPopup: true })} />);
                }
                if (isOwner && clubDetails?.tierType?.isHighSchool && schoolDetailsState?.complete && schoolDetailsState.successful) {
                    const unclaimedPlayersOnRoster = _.some(schoolDetails.roster, (player) => !player.claimed);
                    if (unclaimedPlayersOnRoster) {
                        this.showAdminSplash(
                            <SplashComponents.UnclaimedRosterPlayers handleOnRosterLinkClick={(ev) => {
                                this.handleTabClick(ev, ClubProfileTabIdentifiers.ROSTER);
                                if (this.tabBarRef) {
                                    ReactDOM.findDOMNode(this.tabBarRef)?.scrollIntoView(); //eslint-disable-line
                                }
                            }}
                            />,
                        );
                    }
                }
            }

            const isFreeProCollegeClubAdminOrOwner = userIsFreeCollegeClubOwner(userLoggedIn) || userIsProCollegeAdminOrClubOwner(userLoggedIn);
            const isFreeOrProCollegeClub = isCollegeClub(clubDetails?.tierType?.name);

            const { tabs } = this.state;

            tabs.forEach((tab) => {
                switch (tab.id) {
                    case ClubProfileTabIdentifiers.OVERVIEW:
                        tab.showTab = true;
                        tab.label = (clubTierType.isCollege || clubTierType.isHighSchool) ? 'Team' : null;
                        break;
                    case ClubProfileTabIdentifiers.ROSTER:
                        tab.showTab = clubDetails?.clubHasSchool;
                        break;
                    case ClubProfileTabIdentifiers.SCHEDULE:
                        tab.showTab = clubDetails?.clubHasSchool;
                        break;
                    case ClubProfileTabIdentifiers.RESULTS:
                        if (clubTierType.isHighSchool) {
                            tab.showTab = canPostScores &&
                                !clubTierType.isCollege &&
                                !isTournamentClub(clubTierType) && !isCoachClub(clubTierType);
                        } else if (clubTierType.isCollege) {
                            tab.showTab = true;
                        }
                        if (clubTierType.isHighSchool || clubTierType.isCollege) {
                            tab.sortPosition = ClubProfileTabIdentifiers.EVENTS;
                        }
                        break;
                    case ClubProfileTabIdentifiers.EVENTS:
                        tab.showTab = true;
                        tab.label = clubTierType.isCollege || clubTierType.isHighSchool ? 'Community' : null;
                        tab.newSegment = clubTierType.isCollege || clubTierType.isHighSchool;
                        if (clubTierType.isCollege || clubTierType.isHighSchool) {
                            tab.needsLogin = false;
                            tab.sortPosition = ClubProfileTabIdentifiers.RESULTS;
                        }
                        break;
                    case ClubProfileTabIdentifiers.LEAGUES:
                        tab.showTab = nextProps.showLeaguesTab;
                        break;
                    case ClubProfileTabIdentifiers.MEMBERS:
                        tab.showTab = showPrivateContent && !isTournamentClub(clubTierType);
                        break;
                    case ClubProfileTabIdentifiers.COLLEGE_CORNER:
                        tab.showTab = (clubDetails?.clubType?.label === college) || (isFreeProCollegeClubAdminOrOwner && isFreeOrProCollegeClub);
                        break;
                    default:
                        break;
                }
            });

            tabs.sort((tab1, tab2) => tab1.sortPosition - tab2.sortPosition);
            this.setState({ tabs });
            const { state } = this.props.history.location;
            if (state?.openResultsTab && canPostScores) {
                this.props.getClubResults(true);
                this.props.history.replace({
                    state: null,
                });
                this.handleTabClick(null, ClubProfileTabIdentifiers.RESULTS);
            }

            const isPaidHitClub = clubTierType?.id === ClubTierTypes.PAID_HIT;
            const headOrganizer = find(clubDetails?.clubOrganizers, { role: 'Owner' });
            if (isPaidHitClub && clubDetails.clubOrganizers && !this.props.profile.isLoading && this.props.profile.data.id !== headOrganizer?.playerId) {
                this.props.getOrganizerProfile(headOrganizer?.playerId);
            }
        }
    }

    componentDidUpdate(prevProps) {
        const parsed = queryString.parse(this.props.location.search);
        const { clubDetails } = this.props.club;
        const { user } = this.props.auth;
        if (parsed.showPopup && !this.state.actionPerformed && clubDetails && user) {
            this.handleShowLoginPopUp(parsed.type);
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                actionPerformed: true,
            });
        }

        const tabIdentifier = parsed.t || ClubProfileTabIdentifiers.OVERVIEW;
        const selectedTab = _.find(this.state.tabs, { active: true });
        const userLoggedIn = !!this.props?.auth?.user;
        // chcek if tab needs login
        if (selectedTab?.needsLogin && !userLoggedIn) {
            this.props.history.push({
                search: `?t=${ClubProfileTabIdentifiers.OVERVIEW}`,
            });
        }
        if (selectedTab?.id != tabIdentifier) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState(prevState => {
                const tabs = prevState.tabs.map((tab) => (tab.id == tabIdentifier ? { ...tab, active: true } : { ...tab, active: false }));
                return { tabs };
            });
        }

        // Re-fetch Power 6 data if club ID changes
        const prevClubId = prevProps.club?.clubDetails?.id;
        const currentClubId = clubDetails?.id;
        if (prevClubId !== currentClubId && currentClubId) {
            this.fetchPower6FromRostersApi();
        }
    }

    onInvitePlayersClick() {
        const { clubId } = this.props.club;
        const { clubType } = this.props;
        if (this.props.location.search.indexOf('welcome') > -1) {
            this.props.history.push(`/${clubType}/${clubId}`);
        }
        this.setState({
            showInviteMembersModal: true,
        });
    }

    onSelected(selected) {
        const { user } = this.props.auth;
        const { checkGate, featureGates } = this.props;
        const { clubId } = this.props.match.params;
        const { clubType } = this.props;
        const { clubDetails } = this.props.club;
        const clubTierType = clubDetails.tierType;
        const directAddClubMembersEnabled = checkGate(featureGates.DIRECT_ADD_CLUB_MEMBERS);

        switch (selected.value) {
            case 1: // invite members
                if (!isActive(clubDetails)) {
                    this.setState({ showInactivePopup: true });
                } else {
                    this.onInvitePlayersClick();
                }
                break;
            case 2:
                this.props.history.push(`/${clubType}/${clubId}`);
                this.setState({
                    redirect: true,
                    redirectUrl: `/${clubType}/${clubId}/organizers/add`,
                });
                break;
            case 3:
                if (!clubDetails.isTournamentClub && !clubDetails.isPro && !clubDetails.isSpecial && !clubTierType.isHighSchool && !user.isPowered) {
                    this.setState({ showPowerPopup: true, powerPopupType: 'personal_club_paid_event', handlePowerSuccess: () => { this.handlePowerSuccessForPayment(clubType); } });
                    break;
                }
                this.props.history.push(`/${clubType}/${clubId}`);
                this.setState({
                    redirect: true,
                    redirectUrl: `/${clubType}/${clubId}/payment`,
                });
                break;
            case 4:
                this.props.history.push(`/${clubType}/${clubId}/edit`);
                break;
            case 6:
                this.props.removeClubProfilePhoto(clubId);
                break;
            case 7:
                if (directAddClubMembersEnabled) {
                    this.props.history.push(`/clubs/${clubId}/add-members`);
                }
                break;
            case 8:
                this.props.history.push(`/${clubType}/${clubId}/post-score`);
                break;
            case 9:
                window.open(`${config.userSiteHost}/teammatch`, '_blank');
                break;
            case 10:
                this.createDemoEvent();
                break;
            case 11:
                this.setState({
                    showClubReferralCodePopup: true,
                });
                break;
            case 12:
                this.setState({
                    showHSReferralCodePopup: true,
                });
                break;
            case 13:
                this.props.history.push(`/${clubType}/${clubId}/locations`);
                break;
            default:
                // Do nothing
                break;
        }
    }

    // eslint-disable-next-line react/sort-comp
    handleCreatePaidHitEvent() {
        const paidHitClubMembership = userIsPaidHitter(this.props.auth.user);
        const hasPaidHitClubMembership = !!paidHitClubMembership;

        // If we need to fetch payment accounts, do that first
        if (hasPaidHitClubMembership && !this.props.auth.paidHitClubPaymentAccountsLoaded) {
            this.props.fetchPaidHitClubPaymentAccounts(paidHitClubMembership.clubId).then((data) => {
                const hasPaidHitPaymentAccount = (data?.clubPaymentAccounts || []).length > 0;
                if (hasPaidHitPaymentAccount) {
                    this.props.history.push('/events/create-paid-hit');
                } else {
                    this.props.history.push('/offer-paid-hit');
                }
            });
            return;
        }

        // Check existing payment accounts
        const hasPaidHitPaymentAccount = this.props.auth.paidHitClubPaymentAccounts.length > 0;
        const isPaidHitter = hasPaidHitClubMembership && hasPaidHitPaymentAccount;

        if (isPaidHitter) {
            this.props.history.push('/events/create-paid-hit');
        } else {
            this.props.history.push('/offer-paid-hit');
        }
    }

    onCreateEventClick() {
        const { clubDetails } = this.props.club;
        const { clubType } = this.props;

        if (!isActive(clubDetails)) {
            this.setState({ showInactivePopup: true });
        } else if (isTournamentClub(clubDetails.tierType)) {
            this.props.history.push('/for-events');
        } else if (clubDetails && isClubAdminOrOwner(clubDetails) && isPersonalClub(clubDetails.tierType)) {
            this.schedulePlay(clubType);
        } else if (clubDetails.tierType.id === ClubTierTypes.PAID_HIT) {
            this.handleCreatePaidHitEvent();
        } else {
            this.createEvent(clubType);
        }
    }

    onShowAllEventsClick(ev, eventsType) {
        this.handleTabClick(ev, ClubProfileTabIdentifiers.EVENTS);
        if (eventsType) {
            const { eventsTabState } = this.state;
            eventsTabState.eventsType = eventsType;
            this.setState({
                eventsTabState,
            });
        }
    }

    onTeamMatchMenuSelected(menuOption, eventId) {
        switch (menuOption.value) {
            case 'include_in_standings':
                this.props.includeInHighSchoolStandings(eventId);
                break;
            case 'omit_from_standings':
                this.props.omitFromHighSchoolStandings(eventId);
                break;
            case 'edit':
                this.setState({
                    redirect: true,
                    redirectUrl: `/events/${eventId}`,
                });
                break;
            default:
                break;
        }
    }

    getReferralPopupSetttings(referrerBonus, refereeBonus) {
        // assuming referrer Bonus is UTR Sports credit Referee Bonus is Discount always
        if (referrerBonus && (referrerBonus.amount > 0)) {
            if (refereeBonus && (refereeBonus.amount > 0)) {
                return {
                    title: 'Invite Players',
                    subTitle: `Earn $${referrerBonus.amount} credit when you refer a player who becomes a Power User and they will receive a $${refereeBonus.amount} discount.`,
                    showCreditBalance: true,
                };
            }
            return {
                title: 'Invite Players',
                subTitle: `Earn $${referrerBonus.amount} credit when you refer a player who becomes a Power User.`,
                showCreditBalance: true,
            };
        }
        if (refereeBonus && (refereeBonus.amount > 0)) {
            return {
                title: 'Invite Players',
                subTitle: `Refer your players to sign up for a Power Subscription and they will receive a $${refereeBonus.amount} discount`,
                showCreditBalance: false,
            };
        }
        return {
            title: 'Invite Players',
            subTitle: 'Refer your players to sign up for a Power Subscription',
            showCreditBalance: false,
        };
    }

    setTabBarRef(node) {
        this.tabBarRef = node;
    }

    getCurrentClubAsOptionToUpgrade() {
        const { clubId, clubDetails } = this.props.club;
        const { name } = clubDetails;

        return [{
            value: clubId,
            label: name,
        }];
    }

    handleSuccessReload() {
        setTimeout(() => {
            window.location.reload();
        }, 3000);
    }

    handlePowerSuccessForPayment(clubType) {
        const { clubId } = this.props.club;
        setTimeout(() => {
            this.props.history.push(`/${clubType}/${clubId}/payment`);
        }, 3000);
    }

    showAdminSplash(splashComponent, timeout) {
        this.setState({
            adminSplash: splashComponent,
            showAdminSplash: true,
        });
        if (timeout) {
            setTimeout(() => {
                this.setState({
                    adminSplash: null,
                    showAdminSplash: false,
                });
            }, timeout);
        }
    }

    closePlayerGroupWelcomePopup() {
        removeQueryParam('showPlayerGroupWelcomePopup', this.props);
    }

    createEvent(clubType) {
        this.setState({
            redirect: true,
            redirectUrl: `/events/create?clubId=${this.props.club.clubId}`,
        });
        this.props.history.push(`/${clubType}/${this.props.club.clubId}`);
    }

    schedulePlay(clubType) {
        if (this.props.club.clubDetails && this.props.club.clubDetails.tmsEvents.length > 0) {
            this.setState({
                redirect: true,
                redirectUrl: `/events/create-group-play?clubId=${this.props.club.clubId}`,
            });
        } else {
            this.setState({
                redirect: true,
                redirectUrl: `/events/create-group-play?clubId=${this.props.club.clubId}&flow=personel_club_event_create`,
            });
        }
        this.props.history.push(`/${clubType}/${this.props.club.clubId}`);
    }

    async inviteMembers(members) {
        const membersToInvite = [];
        members.forEach(member => {
            if (member.email) {
                membersToInvite.push(member);
            } else if (member.memberId) {
                membersToInvite.push({
                    memberId: member.memberId,
                });
            }
        });

        await this.props.inviteMembersToClub(membersToInvite);
        this.setState({
            showInviteMembersModal: false,
        });
        if (this.props.club.membersInvited) {
            this.showAdminSplash('Success! Your invitation has been sent.', 3000);
        }
    }

    closeInviteMembersModal() {
        this.setState({
            showInviteMembersModal: false,
        });
    }

    handleTabClick(ev, tabIdentifier) {
        const userLoggedIn = this.props.auth?.user;
        // segment track calls for college corner tabs click - mapped to GA4 from TabBar
        if (window?.analytics && tabIdentifier === ClubProfileTabIdentifiers.COLLEGE_CORNER) {
            window.analytics.track(collegeCornerSegmentTitles.COLLEGE_CORNER_LINK, {
                userId: userLoggedIn?.id,
            });
        }

        const tabToBeSelected = _.find(this.state.tabs, { id: tabIdentifier });

        if ('onClickURL' in tabToBeSelected && 'isURL' in tabToBeSelected && tabToBeSelected?.isURL) {
            tabToBeSelected.onClickURL();
            return;
        }
        if (tabToBeSelected.needsLogin && !userLoggedIn) {
            this.handleShowLoginPopUp(`tab-${tabIdentifier}`);
        } else {
            this.props.history.push({
                search: `?t=${tabIdentifier}`,
            });
            this.setState(prevState => {
                const tabs = prevState.tabs.map((tab) => {
                    return { ...tab, active: tab.id === tabIdentifier };
                });
                return { tabs };
            });
        }
    }

    /* Photo Upload */
    handleHidePhotoEditor() {
        this.setState({ showPhotoEditor: false });
        this.props.clearTempPhoto(true);
    }

    handleUploadPhotoStart() {
        this.setState({ showPhotoEditor: true, photoEditorType: 'club_banner' });
    }

    handleUploadLogoStart() {
        this.setState({ showPhotoEditor: true, photoEditorType: 'club_sponsor_logo' });
    }

    handleUploadClubProfilePhotoStart() {
        this.setState({ showPhotoEditor: true, photoEditorType: 'club_profile' });
    }

    handleUploadPhoto(file) {
        this.props.uploadPhoto(file);
    }

    handleOnRequestPaidHit() {
        this.handleShowLoginPopUp('requestPaidHit');
    }

    async handleCropPhoto(values) {
        const { clubId } = this.props.club;
        await this.props.cropClubBanner(clubId, values);
        this.props.clearTempPhoto(true);
        this.setState({ showPhotoEditor: false });
    }

    async handleCropSponsorLogo(values) {
        const { clubId } = this.props.club;
        await this.props.cropClubSponsorLogo(clubId, values);
        this.props.clearTempPhoto(true);
        this.setState({ showPhotoEditor: false });
    }

    async handleCropClubProfilePhoto(values) {
        const { clubId } = this.props.club;
        await this.props.cropClubProfilePhoto(clubId, values);
        this.props.clearTempPhoto(true);
        this.setState({ showPhotoEditor: false });
    }
    /* End photo upload */

    approveOrRejectRequest(value, request) {
        const { clubDetails, isLoading } = this.props.club;
        const { user } = this.props.auth;
        if (value === 'accept') {
            if (!isActive(clubDetails)) {
                this.setState({ showInactivePopup: true });
                return;
            }
            if (clubDetails.availableMemberSlots === 0) {
                if (user.isPowered) {
                    this.setState({ showMemberLimitPopup: true });
                } else {
                    this.setState({
                        showPowerPopup: true,
                        handlePowerSuccess: this.handleSuccessReload,
                    });
                }
                return;
            }
        }
        if (!isLoading) {
            this.props.approveOrRejectRequest(value, request);
        }
    }

    handleShowLoginPopUp(type) {
        let actionMethod;
        const splitArray = type.split('-');
        switch (splitArray[0]) {
            case 'requesttojoin':
                actionMethod = () => this.handleRequestToJoinClick();
                break;
            case 'tab':
                actionMethod = () => this.handleTabClick(null, parseInt(splitArray[1]));
                break;
            case 'requestPaidHit': {
                if (this.userLoggedIn) {
                    this.setState({ showPaidHitAvailabilityPopup: true });
                }
                break;
            }
            default:
                break;
        }
        const userParamsNeeded = [
            userParams.CLAIMED_PROFILE,
        ];
        if (isLoginPopUpNeeded(this.props.auth, userParamsNeeded)) {
            const popupData = {
                userParamsNeeded,
                titles: titles.REQUEST_TO_JOIN_CLUB,
                performAction: actionMethod,
                type, // should be sent back as query while redirecting from facebook to perform proper action
            };
            this.props.showLoginPopUp(popupData);
        } else if (actionMethod) {
            actionMethod();
        }
    }

    showUpgradeToPowerPopup() {
        this.setState({
            showPowerPopup: true,
            handlePowerSuccess: this.handleSuccessReload,
        });
    }

    handleRequestToJoinClick() {
        const { clubDetails } = this.props.club;
        const { user } = this.props.auth;
        if (clubDetails?.isSpecial) {
            if (!user.isPowered) {
                this.setState({
                    showPowerPopup: true,
                    powerPopupType: 'premium_clubs',
                    handlePowerSuccess: this.handleSuccessReload,
                });
            } else {
                this.props.requestToJoin();
            }
        } else if (!clubDetails.tierType.isTournamentClub) {
            if (clubDetails.currentMember.role === 'Member' || clubDetails.currentMember.role === 'Follower') {
                this.props.requestToUnfollow();
            } else {
                this.props.requestToJoin();
            }
        }
    }

    showUpgradeToProClubCollegePopup() {
        this.setState({ showProClubPopup: true });
    }

    showLearnMoreUtrCollegePopup() {
        this.setState({ showLearnMoreUtrCollegePopup: true });
    }

    showUpgradeToPerformanceHsPopup() {
        this.setState({ showUpgradeToPerformanceHsPopup: true });
    }

    handlePerformanceHsPopupCloseClick() {
        this.setState({
            showUpgradeToPerformanceHsPopup: false,
        });
    }

    handlePerformanceHsPopupUpgradeClick() {
        this.setState({
            showUpgradeToPerformanceHsPopup: false,
            showProClubPopup: true,
        });
    }

    handleOnRequestClosePaidHitPopup() {
        this.setState({ showPaidHitPopupMessage: false });
    }

    handleOnCloseClick() {
        this.setState((prevState) => ({
            rosterTabState: {
                ...prevState.rosterTabState,
                showUpdatePlayerPopUp: false,
                updatePlayerOnRosterPlayerId: null,
                updatePlayerOnRosterPlayerName: null,
            },
        }));
    }

    handleAddPlayerToRosterCtaClick = async (values) => {
        const { checkGate, featureGates } = this.props;
        const isRostersRolloutEnabled = checkGate && featureGates ? checkGate(featureGates.ROSTERS_ROLLOUT) : false;

        const valuesToSave = isRostersRolloutEnabled && values.classYearId
            ? {
                playerId: values.playerId,
                classYearId: parseInt(values.classYearId, 10),
            }
            : {
                playerId: values.playerId,
                gradYear: parseInt(values.playerGradYear, 10),
            };

        try {
            await this.props.addPlayerToRoster(valuesToSave, checkGate, featureGates);
        } catch {
            // Error popup already shown by action; modal is closed in finally
        } finally {
            // Always close the popup whether success or error
            this.setState((prevState) => ({
                rosterTabState: {
                    ...prevState.rosterTabState,
                    showAddPlayerToRosterPopUp: false,
                },
            }));
        }
    };

    handleUpdatePlayerCtaClick = async (values) => {
        const { checkGate, featureGates } = this.props;
        const isRostersRolloutEnabled = checkGate && featureGates ? checkGate(featureGates.ROSTERS_ROLLOUT) : false;

        const valuesToSave = isRostersRolloutEnabled
            ? {
                playerId: values.playerId,
                ...(values.classYearId != null && values.classYearId !== '' ? { classYearId: parseInt(values.classYearId, 10) } : { gradYear: parseInt(values.playerGradYear, 10) }),
            }
            : {
                playerId: values.playerId,
                gradYear: parseInt(values.playerGradYear, 10),
            };

        try {
            await this.props.updatePlayer(valuesToSave, checkGate, featureGates);
        } catch {
            // Error popup already shown by action; modal is closed in finally
        } finally {
            // Always close the popup whether success or error
            this.setState((prevState) => ({
                rosterTabState: {
                    ...prevState.rosterTabState,
                    showUpdatePlayerPopUp: false,
                    updatePlayerOnRosterPlayerId: null,
                    updatePlayerOnRosterPlayerName: null,
                },
            }));
        }
    };

    handleRemovePlayerFromRosterCtaClick = async (values) => {
        const { playerId } = values;
        const { checkGate, featureGates } = this.props;
        await this.props.removePlayerFromRoster(playerId, checkGate, featureGates);
        this.setState((prevState) => ({
            rosterTabState: {
                ...prevState.rosterTabState,
                showRemovePlayerConfirmationPopUp: false,
                removePlayerFromRosterPlayerId: null,
                removePlayerFromRosterPlayerName: null,
            },
        }));
    };

    handleSetRedshirtStatusCtaClick = async (values) => {
        const { checkGate, featureGates } = this.props;
        const { playerId, classYearId } = values;
        await this.props.setPlayerRedshirtStatus(
            {
                playerId,
                classYearId: mapClassYearIdForRedshirt(parseInt(classYearId, 10), true),
                redshirt: true,
            },
            checkGate,
            featureGates,
        );
        this.setState((prevState) => ({
            rosterTabState: {
                ...prevState.rosterTabState,
                showRedshirtConfirmationPopUp: false,
                redshirtPlayerId: null,
                redshirtPlayerName: null,
            },
        }));
    };

    handleRemoveRedshirtStatusCtaClick = async (values) => {
        const { checkGate, featureGates } = this.props;
        const { playerId } = values;
        try {
            await this.props.setPlayerRedshirtStatus(
                {
                    playerId,
                    redshirt: false,
                },
                checkGate,
                featureGates,
            );
        } finally {
            // Always close the popup, whether successful or not (error is handled by action)
            this.setState((prevState) => ({
                rosterTabState: {
                    ...prevState.rosterTabState,
                    showRemoveRedshirtConfirmationPopUp: false,
                    removeRedshirtPlayerId: null,
                    removeRedshirtPlayerName: null,
                },
            }));
        }
    };

    async fetchPower6FromRostersApi() {
        const { clubDetails } = this.props.club;
        const { user } = this.props.auth;
        if (!user) {
            return;
        }

        const isRostersRolloutEnabled = this.props.checkGate(this.props.featureGates.ROSTERS_ROLLOUT);
        if (!isRostersRolloutEnabled || !clubDetails?.id || !clubDetails?.tierType) {
            return;
        }

        const { tierType, id } = clubDetails;

        if (!tierType || !id) {
            return;
        }

        if (!tierType.isCollege && !tierType.isHighSchool) {
            return;
        }

        try {
            const rostersResponse = await rostersApi.getRostersByClubId(
                getRostersApiAxiosInstance(),
                id,
            );

            if (!rostersResponse?.data?.success) {
                this.setState({ power6Data: null });
                return;
            }

            const { rosterId } = rostersResponse.data?.data || {};
            if (!rosterId) {
                this.setState({ power6Data: null });
                return;
            }

            const power6Response = await rostersApi.getRosterPower6(
                getRostersApiAxiosInstance(),
                rosterId,
            );

            // Silent fail for background fetch - no popup, just set null
            if (power6Response?.data?.success === false) {
                this.setState({ power6Data: null });
                return;
            }

            // Store the entire power6 data object (includes rating, high, and low)
            const power6DataFromApi = power6Response.data?.data ?? null;
            this.setState({ power6Data: power6DataFromApi });
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Error fetching Power 6 data from rosters API:', error);
            this.setState({ power6Data: null });
        }
    }

    handleCloseCompareTeamPopUp() {
        this.setState((prevState) => ({
            rosterTabState: {
                ...prevState.rosterTabState,
                showCompareTeamPopUp: false,
            },
        }));
    }

    handleCloseAddPlayerToRosterPopUp() {
        this.setState((prevState) => ({
            rosterTabState: {
                ...prevState.rosterTabState,
                showAddPlayerToRosterPopUp: false,
            },
        }));
    }

    handleCloseRemovePlayerConfirmationPopUp() {
        this.setState((prevState) => ({
            rosterTabState: {
                ...prevState.rosterTabState,
                showRemovePlayerConfirmationPopUp: false,
                removePlayerFromRosterPlayerId: null,
                removePlayerFromRosterPlayerName: null,
            },
        }));
    }

    handleRedshirtCloseClick() {
        this.setState((prevState) => ({
            rosterTabState: {
                ...prevState.rosterTabState,
                showRedshirtConfirmationPopUp: false,
                redshirtPlayerId: null,
                redshirtPlayerName: null,
            },
        }));
    }

    handleRemoveRedshirtCloseClick() {
        this.setState((prevState) => ({
            rosterTabState: {
                ...prevState.rosterTabState,
                showRemoveRedshirtConfirmationPopUp: false,
                removeRedshirtPlayerId: null,
                removeRedshirtPlayerName: null,
            },
        }));
    }

    renderUpdatePlayerPopUp(isRostersRolloutEnabled) {
        const { clubDetails, schoolDetails } = this.props.club;
        const isAdminOrOwner = isClubAdminOrOwner(clubDetails);
        const clubSubTypeId = clubDetails?.clubSubType?.id ?? 0;

        const shouldShowUpdatePlayerPopUp = this.state.rosterTabState.showUpdatePlayerPopUp && isAdminOrOwner;
        if (!shouldShowUpdatePlayerPopUp) {
            return null;
        }

        // Find the current player to get their existing redshirt status and class year
        const currentPlayerId = this.state.rosterTabState.updatePlayerOnRosterPlayerId;
        const currentPlayer = (schoolDetails?.roster || []).find((p) => p.id === currentPlayerId);
        const actualClassYearId = currentPlayer && isRostersRolloutEnabled
            ? getClassYearIdFromStatus(currentPlayer.classYearStatus)
            : null;

        const currentClassYearId = actualClassYearId;
        const currentRedshirt = currentPlayer?.redshirt || false;

        return (
            <AddUpdatePlayerOnRosterPopUp
                playerId={currentPlayerId}
                playerName={this.state.rosterTabState.updatePlayerOnRosterPlayerName}
                checkGate={this.props.checkGate}
                featureGates={this.props.featureGates}
                isCollege={clubDetails?.tierType?.isCollege}
                currentClassYearId={currentClassYearId}
                currentRedshirt={currentRedshirt}
                onCloseClick={this.handleOnCloseClick}
                onCtaClick={this.handleUpdatePlayerCtaClick}
                clubSubTypeId={clubSubTypeId}
            />
        );
    }

    renderRedshirtConfirmationPopUp(isRostersRolloutEnabled) {
        const { clubDetails, schoolDetails } = this.props.club;
        const isAdminOrOwner = isClubAdminOrOwner(clubDetails);

        const shouldShowRedshirtConfirmationPopUp = this.state.rosterTabState.showRedshirtConfirmationPopUp && isAdminOrOwner && isRostersRolloutEnabled;
        if (!shouldShowRedshirtConfirmationPopUp) {
            return null;
        }

        // Find the current player to get their existing class year
        const currentPlayerId = this.state.rosterTabState.redshirtPlayerId;
        const currentPlayer = (schoolDetails?.roster || []).find((p) => p.id === currentPlayerId);
        let defaultClassYearId = CLASS_YEAR_IDS.FRESHMAN; // Default to Freshman
        if (currentPlayer && isRostersRolloutEnabled && currentPlayer.classYearStatus) {
            const actualClassYearId = getClassYearIdFromStatus(currentPlayer.classYearStatus);
            if (actualClassYearId) {
                // Map to dropdown value (Graduate Student -> Senior)
                defaultClassYearId = mapClassYearIdToDropdown(actualClassYearId);
            }
        }

        return (
            <ConfirmRedshirtStatusPopUp
                playerId={this.state.rosterTabState.redshirtPlayerId}
                playerName={this.state.rosterTabState.redshirtPlayerName}
                defaultClassYearId={defaultClassYearId}
                onCloseClick={this.handleRedshirtCloseClick}
                onCtaClick={this.handleSetRedshirtStatusCtaClick}
            />
        );
    }

    renderRemoveRedshirtConfirmationPopUp(isRostersRolloutEnabled) {
        const { clubDetails } = this.props.club;
        const isAdminOrOwner = isClubAdminOrOwner(clubDetails);

        const shouldShowRemoveRedshirtConfirmationPopUp = this.state.rosterTabState.showRemoveRedshirtConfirmationPopUp && isAdminOrOwner && isRostersRolloutEnabled;
        if (!shouldShowRemoveRedshirtConfirmationPopUp) {
            return null;
        }

        return (
            <RemoveRedshirtStatusPopUp
                playerId={this.state.rosterTabState.removeRedshirtPlayerId}
                playerName={this.state.rosterTabState.removeRedshirtPlayerName}
                onCloseClick={this.handleRemoveRedshirtCloseClick}
                onCtaClick={this.handleRemoveRedshirtStatusCtaClick}
            />
        );
    }

    async handleRequestPaidHitSubmit({ values }) {
        this.setState({
            isSendingPaidHitRequest: true,
            showPaidHitAvailabilityPopup: false,
        });
        const { profile } = this.props;
        const playerId = profile?.data?.id;
        const playerRanks = profile?.ptsRankings?.rankings;
        const maxRank = 1;
        const minRank = 100;
        const isProfessionallyRanked = playerRanks ? playerRanks.some(ranking => ranking.rank >= maxRank && ranking.rank <= minRank) : false;
        const isPaidHitter = profile?.data?.isPaidHitter;
        const playerName = profile?.data?.displayName;
        let popupMessage = '';
        let isSuccessfulRequest = false;

        try {
            await requestPaidHitForPlayer(getApiAxiosInstance(), { requestedPlayerId: playerId, message: values.message });
            isSuccessfulRequest = true;
            this.setState({ isSendingPaidHitRequest: false });
        } catch (e) {
            this.props.showErrorPopup({
                message: 'Error requesting Paid Hit',
                error: e,
            });
        }

        if (isSuccessfulRequest) {
            if (isProfessionallyRanked) {
                popupMessage = 'We\'ve got your request for this Pro player and will let them know that you want to do a paid hit with them!';
            } else if (isPaidHitter && !isProfessionallyRanked) {
                popupMessage = 'We\'ve sent this paid hitter your request for a paid hit!';
            } else {
                popupMessage = `Thanks for your interest in hitting with ${playerName}, we will reach out to them to encourage them to become a Paid Hitter.`;
            }
            this.setState({ paidHitPopupMessage: popupMessage, showPaidHitPopupMessage: true });
        }
    }

    async sendMessage(recipient) {
        const { auth } = this.props;

        if (recipient?.memberId && auth?.user?.id !== recipient.memberId) {
            this.props.msgSetNewConv(true);
            this.props.msgAddRecipient(recipient);
            this.props.history.push(`/inbox`);
        }
    }

    createDemoEvent() {
        const { clubType } = this.props;
        this.setState({
            redirect: true,
            redirectUrl: `/events/create?clubId=${this.props.club.clubId}&demoEvent=true`,
        });
        this.props.history.push(`/${clubType}/${this.props.club.clubId}`);
    }

    openPendingRequests(ev) {
        this.handleTabClick(ev, ClubProfileTabIdentifiers.MEMBERS);
        const { membersTabState } = this.state;
        membersTabState.adminViewType = 'requests';
        membersTabState.requestViewType = 'Pending';
        this.setState({
            membersTabState,
        });
    }

    showOrganizerLimitPopup(type) {
        this.setState({ showOrganizerLimitPopup: true, organizerLimitType: type });
    }

    showMessagePopUp() {
        this.setState({
            message: {
                showModal: true,
                title: 'Message all members',
                subTitle: 'Send an email update to all members in the club.',
                placeholder: 'Type message to include in email to all members.',
                ctaText: 'Send Message',
            },
        });
    }

    closeMessagePopUp() {
        this.setState({
            message: {
                showModal: false,
                title: null,
                subTitle: null,
                placeholder: null,
                ctaText: null,
            },
        });
    }

    handleRosterLockedPopUpCloseClick() {
        this.setState((prevState) => ({
            rosterTabState: {
                ...prevState.rosterTabState,
                showRosterLockedPopUp: false,
            },
        }));
    }

    exportMembers() {
        const { clubId } = this.props.club;
        const userId = this.props.auth?.user?.id;
        const memberExportSegementTitle = 'Club Tab Export Members Clicked';
        if (window?.analytics) {
            window.analytics.track(memberExportSegementTitle, {
                userId,
                clubId,
            });
        }

        this.membersExportLink.href = `/api/v1/club/${clubId}/members/export`;
        this.membersExportLink.click();
    }

    render() {
        const { auth, coreUI, profile: headOrganizer, checkGate, featureGates } = this.props;
        const user = this.props.auth?.user || {};
        const collegeDualMatchFlagEnabled = checkGate(featureGates.COLLEGE_DUAL_MATCH);
        const { clubDetails, clubId, schoolDetails, schoolDetailsState, tmsEventsFetchState, clubMembersFetchState, clubTeamRatings, resultsFetchState, power6Stats, power6StatsState, isSaving, highSchoolStandingsSeasons, highSchoolStandings, highSchoolStandingsState } = this.props.club;
        const clubStatus = clubDetails?.statusType;
        const clubIsFreeCollege = clubDetails?.isFreeCollege;
        const clubIdInUrl = this.props.match.params.clubId;
        const { clubType } = this.props;
        const clubSubTypeId = clubDetails?.clubSubType ? clubDetails.clubSubType.id : 0;
        const clubTierType = clubDetails?.tierType || {};
        const { schoolProfile, name, description, id } = clubDetails || {};
        const isCollegeOrHighSchool = clubDetails && (clubTierType.isCollege || clubTierType.isHighSchool);
        const isPaidHitClub = clubTierType?.id === ClubTierTypes.PAID_HIT;
        const isMember = isClubMember(clubDetails);
        const { showPlayerGroupWelcomePopup } = queryString.parse(this.props.location.search);
        const clubIsFreeSchool = clubDetails?.isFreeSchool;
        const selectedTab = _.find(this.state.tabs, { active: true });
        const referralsEnabled = checkGate(featureGates.REFERRAL_SYSTEM);
        const directAddClubMembersEnabled = checkGate(featureGates.DIRECT_ADD_CLUB_MEMBERS);

        // rewrite route if type mistmatch
        if (!_.isEmpty(clubTierType) && clubId === clubIdInUrl) {
            if (clubType === 'clubs') {
                if (clubTierType.isCollege) {
                    return <Redirect to={`/colleges/${clubId}`} />;
                }

                if (clubTierType.isHighSchool) {
                    return <Redirect to={`/schools/${clubId}`} />;
                }
            } else if (clubType === 'schools') {
                if (clubTierType.isCollege) {
                    return <Redirect to={`/colleges/${clubId}`} />;
                }

                if (!clubTierType.isHighSchool) {
                    return <Redirect to={`/clubs/${clubId}`} />;
                }
            } else if (clubType === 'colleges') {
                if (clubTierType.isHighSchool) {
                    return <Redirect to={`/schools/${clubId}`} />;
                }

                if (!clubTierType.isCollege) {
                    return <Redirect to={`/clubs/${clubId}`} />;
                }
            } else if (clubType === 'groups') {
                if (clubTierType.isCollege) {
                    return <Redirect to={`/colleges/${clubId}`} />;
                }

                if (clubTierType.isHighSchool) {
                    return <Redirect to={`/schools/${clubId}`} />;
                }

                if (!isPersonalClub(clubTierType)) {
                    return <Redirect to={`/clubs/${clubId}`} />;
                }
            }
        }

        const canRunEvents = !_.isEmpty(clubTierType) ? clubTierType.canRunEvents : false;
        const { componentConfig } = this.props;
        const compConfig = componentConfig['club-profile'];
        const collegeIntroPopUpConfig = compConfig?.modals?.find(m => m.type === 'college_club_intro_popup');

        let collegeIntroPopUp = null;
        if (collegeIntroPopUpConfig) {
            const axiosInstance = getApiAxiosInstance();
            collegeIntroPopUp = (
                <CollegeClubIntroPopUp
                    onCloseClick={() => {
                        this.setState({ showUtrCollegeIntroPopup: false });
                        postComponentAction(axiosInstance, 'club-profile', collegeIntroPopUpConfig.actions.dismissed.event, { properties: { clubId } });
                    }}
                    onCtaClick={() => {
                        this.setState({ showUtrCollegeIntroPopup: false });
                        postComponentAction(axiosInstance, 'club-profile', collegeIntroPopUpConfig.actions.dismissed.event, { properties: { clubId } });
                    }}
                />
            );
        }
        const isOwner = isClubOwner(clubDetails);
        const isAdminOrOwner = isClubAdminOrOwner(clubDetails);
        const isPersonal = clubDetails && isPersonalClub(clubDetails.tierType);
        const clubAllowOffPlatformPayments = clubDetails?.allowOffPlatformPayments;
        const tierType = clubDetails?.tierType;
        const referralURL = clubDetails ? getReferralUrl(clubDetails.referralCode) : '';
        const highSchoolReferralURL = clubDetails ? getHSClaimReferralUrl(clubDetails.referralCode) : '';

        let menuList = [
            {
                label: 'Edit profile',
                value: 4,
                showOption: true,
            },
            {
                label: 'Add Providers',
                value: 2,
                showOption: clubDetails?.canHaveMultipleAdmins && !clubDetails.isEnterprise && !clubDetails.isPro && !isPaidHitClub,
            },
            {
                label: 'Invite Members',
                value: 1,
                showOption: clubDetails?.isEnterprise || clubDetails?.isPro || clubTierType.isCollege || clubDetails?.isPremium,
            },
            {
                label: 'Event Payments Account',
                value: 3,
                showOption: !isPersonal && !clubAllowOffPlatformPayments,
            },
            {
                label: 'Remove Profile Photo',
                value: 6,
                showOption: isAdminOrOwner,
            },
            {
                label: 'Add Members',
                value: 7,
                showOption: clubDetails && !tierType?.isHighSchool && directAddClubMembersEnabled,
            },
            {
                label: 'Post Scores',
                value: 8,
                showOption: false,
            },
            {
                label: 'Enter Scores - old tool',
                value: 9,
                showOption: false,
            },
            {
                label: 'Create Demo Event',
                value: 10,
                showOption: clubDetails?.demoEventCount === 0 && !isPaidHitClub,
            },
            {
                label: 'Power Upgrade Link',
                value: 11,
                showOption: !!clubDetails?.referralCode && (referralsEnabled || clubDetails.isEnterprise || clubDetails.isPremium),
            },
            {
                label: 'Invite School Coaches',
                value: 12,
                showOption: referralsEnabled && !!clubDetails?.referralCode && clubTierType.isHighSchool && isAdminOrOwner,
            },
            {
                label: 'Locations and Courts',
                value: 13,
                showOption: !isPaidHitClub,
            },
        ];

        // add GTM click attributes to menu items
        menuList = menuList.map(menuItem => {
            return {
                ...menuItem,
                clickCategory: 'Club Profile',
                clickContext: menuItem.label,
                clickLocation: 'Club Profile Header Popover Menu',
            };
        });

        const referralPopupSettings = clubDetails && this.getReferralPopupSetttings(clubDetails.referrerBonus, clubDetails.refereeBonus);
        const displayResultsTab = selectedTab?.id === ClubProfileTabIdentifiers.RESULTS;
        const displayEventsTab = selectedTab?.id === ClubProfileTabIdentifiers.EVENTS;

        const displayName = clubTierType && getClubNameDisplay(clubTierType, schoolProfile, name);
        const isRostersRolloutEnabled = checkGate && featureGates ? checkGate(featureGates.ROSTERS_ROLLOUT) : false;

        return (
            <div>
                {head({
                    title: displayName ? `UTR Sports | ${displayName}` : config.defaultTitle,
                    description,
                    url: `${config.appHost}/clubs/${id}`,
                    keywords: 'Tennis Clubs, Tennis Events, UTR Sports Tournaments',
                    image: `https://www.${config.siteBaseUrl}/img/utr_sports/utr-sports-logo.svg`,
                    imageWidth: '930',
                    imageHeight: '395',
                })}
                <a
                    ref={el => {
                        this.membersExportLink = el;
                    }}
                    className="d-none"
                    target="_blank"
                    data-testid="club-profile.members-export-link"
                />
                {clubDetails && (
                    <div className={`${styles.clubProfile}`}>
                        {this.state.showAdminSplash && (
                            <div className={`${styles.section} sub-header admin-splash bg-black`}>
                                <div className={`container bg-transparent`}>
                                    <div className="row">
                                        <div className={`col d-flex align-items-center justify-content-center text-center`}>
                                            <h6 data-testid="club-profile.admin-splash.message">
                                                {this.state.adminSplash}
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        <ClubProfileHeader
                            userLoggedIn={this.props.auth}
                            menuOptions={menuList.filter(option => option.showOption)}
                            clubDetails={clubDetails}
                            clubTeamRatings={clubTeamRatings}
                            onSelected={this.onSelected}
                            clubType={clubType}
                            onCreateEventClick={this.onCreateEventClick}
                            handleRequestToJoinClick={() => {
                                this.handleShowLoginPopUp('requesttojoin');
                            }}
                            submitting={isSaving}
                            test={this.state.test}
                            onRegistrationClick={(ev) => this.handleTabClick(ev, ClubProfileTabIdentifiers.EVENTS)}
                            removeBannerPhoto={this.props.removeBannerPhoto}
                            handleUploadPhoto={this.handleUploadPhoto}
                            handleUploadClubProfilePhotoStart={this.handleUploadClubProfilePhotoStart}
                            handleUploadPhotoStart={this.handleUploadPhotoStart}
                            openPendingRequests={this.openPendingRequests}
                            showLearnMoreUtrCollegePopup={this.showLearnMoreUtrCollegePopup}
                            showUpgradeToPerformanceHsPopup={this.showUpgradeToPerformanceHsPopup}
                            handleOnRequestPaidHitClicked={this.handleOnRequestPaidHit}
                            power6Data={this.state.power6Data}
                        />
                        <TabBar
                            tabs={this.state.tabs}
                            handleTabClick={this.handleTabClick}
                            ref={this.setTabBarRef}
                            showLabels={isCollegeOrHighSchool}
                            eventName="Club Tab Clicked"
                            clickCategory="Club Profile"
                            clickLocation="Club Tabs"
                            data-testid="club-profile.tab-bar"
                        />
                        <div className={`${styles.content}`} data-testid="club-profile.content">
                            <div className={`container`}>
                                {selectedTab?.id === ClubProfileTabIdentifiers.OVERVIEW && (
                                    <OverviewTabContent
                                        clubDetails={clubDetails}
                                        auth={auth}
                                        coreUI={coreUI}
                                        isAdminOrOwner={isAdminOrOwner}
                                        isClubMember={isMember}
                                        clubType={clubType}
                                        handleUploadPhoto={this.handleUploadPhoto}
                                        handleUploadLogoStart={this.handleUploadLogoStart}
                                        removeSponsorLogo={this.props.removeSponsorLogo}
                                        tmsEventsFetchState={tmsEventsFetchState}
                                        schoolDetailsState={schoolDetailsState}
                                        schoolDetails={schoolDetails}
                                        handleTabClick={this.handleTabClick}
                                        onUpgradeToCollegeClick={this.showLearnMoreUtrCollegePopup}
                                        onShowAllEventsClick={this.onShowAllEventsClick}
                                        onCreateEventClick={this.onCreateEventClick}
                                        sendMessage={this.sendMessage}
                                        rosterTabState={this.state.rosterTabState}
                                        updateRosterTabState={(rosterTabState) => {
                                            this.setState({
                                                rosterTabState,
                                            });
                                        }}
                                        power6Stats={power6Stats}
                                        power6StatsState={power6StatsState}
                                        getPower6Stats={this.props.getPower6Stats}
                                        highSchoolStandingsSeasons={highSchoolStandingsSeasons}
                                        highSchoolStandings={highSchoolStandings}
                                        highSchoolStandingsState={highSchoolStandingsState}
                                        getHighSchoolStandingsSeasons={this.props.getHighSchoolStandingsSeasons}
                                        getHighSchoolStandings={this.props.getHighSchoolStandings}
                                    />
                                )}
                                {selectedTab?.id === ClubProfileTabIdentifiers.ROSTER && (
                                    <RosterTabContent
                                        clubDetails={clubDetails}
                                        schoolDetails={schoolDetails}
                                        schoolDetailsState={schoolDetailsState}
                                        auth={auth}
                                        clubType={clubType}
                                        rosterTabState={this.state.rosterTabState}
                                        updateRosterTabState={(rosterTabState) => {
                                            this.setState({
                                                rosterTabState,
                                            });
                                        }}
                                        power6Data={this.state.power6Data}
                                    />
                                )}
                                {selectedTab?.id === ClubProfileTabIdentifiers.SCHEDULE && (
                                    <ScheduleTabContent
                                        clubDetails={clubDetails}
                                        auth={this.props.auth}
                                        eventsTypeName={`Team Events`}
                                        tmsEventsFetchState={tmsEventsFetchState}
                                        fetchClubTMSEventsList={this.props.getClubTMSEventsList}
                                        isAdminOrOwner={isAdminOrOwner}
                                        onCreateEventClick={this.onCreateEventClick}
                                        onTeamMatchMenuSelected={this.onTeamMatchMenuSelected}
                                        highSchoolStandingsSeasons={highSchoolStandingsSeasons}
                                        getHighSchoolStandingsSeasons={this.props.getHighSchoolStandingsSeasons}
                                        collegeDualMatchFlagEnabled={collegeDualMatchFlagEnabled}
                                    />
                                )}
                                <div
                                    className={`${displayEventsTab ? 'd-block' : 'd-none'}`}
                                >
                                    <EventsTabContent
                                        clubDetails={clubDetails}
                                        eventsTabState={this.state.eventsTabState}
                                        auth={this.props.auth}
                                        coreUI={coreUI}
                                        updateEventsTabState={(eventsTabState) => {
                                            this.setState({
                                                eventsTabState,
                                            });
                                        }}
                                        isAdminOrOwner={isAdminOrOwner}
                                        isClubMember={isMember}
                                        canRunEvents={canRunEvents}
                                        isPersonalClub={isPersonalClub(clubTierType)}
                                        isTournamentClub={isTournamentClub(clubTierType)}
                                        isOwner={isOwner}
                                        tmsEventsFetchState={tmsEventsFetchState}
                                        clubIsFreeCollege={clubIsFreeCollege}
                                        onUpgradeToCollegeClick={this.showLearnMoreUtrCollegePopup}
                                        onShowAllClick={this.onShowAllEventsClick}
                                        onCreateEventClick={this.onCreateEventClick}
                                        fetchClubTMSEventsList={this.props.getClubTMSEventsList}
                                        fetchClubDraftTMSEventsList={this.props.getClubDraftEventsList}
                                        clubIsFreeSchool={clubIsFreeSchool}
                                        onUpgradePerformanceHsClick={this.showUpgradeToPerformanceHsPopup}
                                    />
                                </div>
                                <div
                                    className={`${displayResultsTab ? 'd-block' : 'd-none'}`}
                                >
                                    <ResultsTabContent
                                        clubDetails={clubDetails}
                                        isAdminOrOwner={isAdminOrOwner}
                                        auth={auth}
                                        clubType={clubType}
                                        handleUploadPhoto={this.handleUploadPhoto}
                                        handleUploadLogoStart={this.handleUploadLogoStart}
                                        removeSponsorLogo={this.props.removeSponsorLogo}
                                        resultsType={this.props.club.resultsType == 'd' ? 'doubles' : 'singles'}
                                        results={this.props.club.results}
                                        changeResultsType={this.props.changeResultsType}
                                        sendMessage={this.sendMessage}
                                        resultsFetchState={resultsFetchState}
                                        fetchClubResults={this.props.getClubResults}
                                        showInactivePopup={() => {
                                            this.setState({
                                                showInactivePopup: true,
                                            });
                                        }}
                                        highSchoolStandingsSeasons={highSchoolStandingsSeasons}
                                        getHighSchoolStandingsSeasons={this.props.getHighSchoolStandingsSeasons}
                                    />
                                </div>
                                {selectedTab?.id === ClubProfileTabIdentifiers.LEAGUES && (
                                    <LeaguesTabContent
                                        type={'club'}
                                        clubLeagues={this.props?.clubLeagues}
                                        onContactClick={() => {
                                            this.handleShowLoginPopUp('requesttojoin');
                                        }}
                                    />
                                )}
                                {selectedTab?.id === ClubProfileTabIdentifiers.MEMBERS && (
                                    <ConnectedMembersTabContent
                                        clubDetails={clubDetails}
                                        auth={auth}
                                        clubType={clubType}
                                        membersTabState={this.state.membersTabState}
                                        clubMembersFetchState={clubMembersFetchState}
                                        clubMemberRoles={this.props.coreUI.types.clubMemberRole}
                                        updateMembersTabState={(membersTabState) => {
                                            this.setState({
                                                membersTabState,
                                            });
                                        }}
                                        approveOrRejectRequest={this.approveOrRejectRequest}
                                        resendInvite={this.props.resendInvite}
                                        deleteInvite={this.props.deleteInvite}
                                        updateMemberRole={this.props.updateMemberRole}
                                        updateMemberType={this.props.updateMemberType}
                                        updateClubMemberPower={this.props.updateClubMemberPower}
                                        showError={this.props.showError}
                                        showOrganizerLimitPopup={this.showOrganizerLimitPopup}
                                        sendMessage={this.sendMessage}
                                        showUpgradeToPowerPopup={this.showUpgradeToPowerPopup}
                                        showMessagePopUp={this.showMessagePopUp}
                                        exportMembers={this.exportMembers}
                                        showInviteMembersModal={this.onInvitePlayersClick}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                )}
                {this.state.redirect && (
                    <Redirect to={this.state.redirectUrl} />
                )}
                {(isAdminOrOwner) && (
                    <PhotoEditor
                        showEditor={this.state.showPhotoEditor}
                        closeEditor={this.handleHidePhotoEditor}
                        imageUrl={this.props.uploads.tempPhotoUrl}
                        data-testid="modal.club-profile.photo-editor"
                        uploadCropData={(values) => {
                            switch (this.state.photoEditorType) {
                                case 'club_banner':
                                    this.handleCropPhoto(values);
                                    break;
                                case 'club_sponsor_logo':
                                    this.handleCropSponsorLogo(values);
                                    break;
                                case 'club_profile':
                                    this.handleCropClubProfilePhoto(values);
                                    break;
                                default:
                                    break;
                            }
                        }}
                        type={this.state.photoEditorType}
                        radius={this.state.photoEditorType == 'club_profile' ? 400 : 0}
                    />
                )}
                <ClubInactivePopup
                    show={this.state.showInactivePopup}
                    close={() => this.setState({ showInactivePopup: false })}
                    status={clubStatus ? clubStatus.value : null}
                    clubTierType={clubTierType}
                />
                <OrganizerLimitPopup
                    show={this.state.showOrganizerLimitPopup}
                    close={() => this.setState({ showOrganizerLimitPopup: false, organizerLimitType: null })}
                    type={this.state.organizerLimitType}
                />
                <MemberLimitPopup
                    show={this.state.showMemberLimitPopup}
                    close={() => this.setState({ showMemberLimitPopup: false })}
                />
                {this.state.showClubReferralCodePopup && (
                    <ReferralCodePopUp
                        title={referralPopupSettings.title}
                        dangerouslySetInnerHTML={true}
                        subtitleClick={(e) => {
                            if (e.target.className == 'power') {
                                this.showUpgradeToPowerPopup();
                            }
                        }}
                        subtitle={referralPopupSettings.subTitle}
                        text={'Your Club’s Unique Referral Invite Link'}
                        url={referralURL}
                        promoCreditBalance={referralPopupSettings.showCreditBalance && clubDetails.clubPromoCreditBalance}
                        onCloseClick={() => this.setState({ showClubReferralCodePopup: false })}
                    />
                )}
                {this.state.showHSReferralCodePopup && (
                    <ReferralCodePopUp
                        title={'Invite Coaches'}
                        subtitle={'Earn credit when you refer a Coach who claims his School Club.'}
                        text={'Your Club’s Unique Referral Invite Link'}
                        url={highSchoolReferralURL}
                        promoCreditBalance={clubDetails.clubPromoCreditBalance}
                        onCloseClick={() => this.setState({ showHSReferralCodePopup: false })}
                    />
                )}
                {this.state.showPowerPopup && this.props.auth?.user?.hasPastDueSubscription && (
                    <Redirect to={SUBSCRIPTIONS_PATH} />
                )}
                {this.state.showPowerPopup && !this.props.auth?.user?.hasPastDueSubscription && (
                    <UpgradeToPowerPopUp
                        type={this.state.powerPopupType}
                        onCloseClick={() => this.setState({ showPowerPopup: false })}
                        onSuccess={this.state.handlePowerSuccess}
                    />
                )}
                {(this.state.showLearnMoreUtrCollegePopup) && (
                    <LearnMoreUtrCollegePopUp
                        data-testid="modal.club-profile.learn-more-college"
                        onCloseClick={() => {
                            this.setState({
                                showLearnMoreUtrCollegePopup: false,
                            });
                        }}
                        handleUpgradeClick={() => {
                            this.setState({
                                showLearnMoreUtrCollegePopup: false,
                                showProClubPopup: true,
                            });
                        }}
                        clubOptionsToUpgrade={this.getCurrentClubAsOptionToUpgrade()}
                    />
                )}
                {(this.state.showUpgradeToPerformanceHsPopup) && (
                    <UpgradeToPerformanceHsPopUp
                        onCloseClick={this.handlePerformanceHsPopupCloseClick}
                        handleUpgradeClick={this.handlePerformanceHsPopupUpgradeClick}
                        clubOptionsToUpgrade={this.getCurrentClubAsOptionToUpgrade()}
                    />
                )}
                {(this.state.showUtrCollegeIntroPopup) && (
                    collegeIntroPopUp
                )}
                {this.state.showProClubPopup && (
                    <UpgradeToProClubPopUp
                        data-testid="modal.club-profile.upgrade-pro-club"
                        skipIntro={true}
                        onCloseClick={() => this.setState({ showProClubPopup: false })}
                        onSuccess={this.handleSuccessReload}
                        clubId={clubId}
                        clubTierType={clubTierType}
                        clubName={clubDetails.name}
                    />
                )}
                {this.state.rosterTabState.showCompareTeamPopUp && (
                    <CompareTeamPopUp
                        onCloseClick={this.handleCloseCompareTeamPopUp}
                        clubSubType={clubDetails.clubSubType}
                        type={clubTierType.isCollege ? 'college' : 'highschool'}
                        clubId={clubId}
                    />
                )}
                {this.state.showOrganizerWelcomeScreen && isAdminOrOwner && !clubTierType.isHighSchool && (
                    <OrganizerWelcomePopUp
                        onCloseClick={() => {
                            this.setState({
                                showOrganizerWelcomeScreen: false,
                            });
                        }}
                        onCtaClick={() => {
                            this.setState({
                                showOrganizerWelcomeScreen: false,
                            });
                            this.crateEvent(clubType);
                        }}
                        memberName={user.firstName}
                    />
                )}
                {this.state.rosterTabState.showAddPlayerToRosterPopUp && isAdminOrOwner && (
                    <AddUpdatePlayerOnRosterPopUp
                        showAddPlayer={true}
                        checkGate={this.props.checkGate}
                        featureGates={this.props.featureGates}
                        isCollege={clubDetails?.tierType?.isCollege}
                        onCloseClick={this.handleCloseAddPlayerToRosterPopUp}
                        onCtaClick={this.handleAddPlayerToRosterCtaClick}
                        clubSubTypeId={clubSubTypeId}
                    />
                )}
                {this.renderUpdatePlayerPopUp(isRostersRolloutEnabled)}
                {this.state.rosterTabState.showRemovePlayerConfirmationPopUp && isAdminOrOwner && (
                    <RemovePlayerFromRosterPopUp
                        playerId={this.state.rosterTabState.removePlayerFromRosterPlayerId}
                        playerName={this.state.rosterTabState.removePlayerFromRosterPlayerName}
                        onCloseClick={this.handleCloseRemovePlayerConfirmationPopUp}
                        onCtaClick={this.handleRemovePlayerFromRosterCtaClick}
                    />
                )}
                {this.renderRedshirtConfirmationPopUp(isRostersRolloutEnabled)}
                {this.renderRemoveRedshirtConfirmationPopUp(isRostersRolloutEnabled)}
                {this.state.rosterTabState.showRosterLockedPopUp && isAdminOrOwner && (
                    <RosterLockedPopUp
                        onCloseClick={this.handleRosterLockedPopUpCloseClick}
                        lockEndDate={formatLockEndDate(schoolDetails?.lockEndDate)}
                    />
                )}

                {showPlayerGroupWelcomePopup && (
                    <WelcomePopUp
                        dangerouslySetInnerHTML={true}
                        welcomeTitles={{
                            title: 'Arrange tennis activity for your group!',
                            subTitle: 'Invite group members and create tennis events',
                            description: 'Connect and schedule casual or competitive play with up to 25 of your regular tennis friends. If you’re trying to organize a competitive tournaments, please become a UTR Sports Organizer <a href="/create-event" target="_blank">here</a>',
                        }}
                        onCloseClick={() => {
                            this.closePlayerGroupWelcomePopup();
                        }}
                        onCtaClick={() => {
                            this.closePlayerGroupWelcomePopup();
                        }}
                    />
                )}

                {this.state.message && this.state.message.showModal && (
                    <MessagePopUp
                        onCloseClick={this.closeMessagePopUp}
                        title={this.state.message.title}
                        subTitle={this.state.message.subTitle}
                        placeHolder={this.state.message.placeholder}
                        sendText={this.state.message.ctaText}
                        onSendClick={({ values }) => {
                            this.props.sendMessageToMembers(values.notes, clubId);
                            this.closeMessagePopUp();
                        }}
                    />
                )}

                {this.state.showInviteMembersModal && (
                    <InviteMembersModal
                        title={`Invite Players to Your Club`}
                        onCloseClick={this.closeInviteMembersModal}
                        onActionClick={this.inviteMembers}
                    />
                )}

                {this.state.showPaidHitPopupMessage && (
                    <GenericPopup
                        title="Request Sent for Paid Hit"
                        subtitle={this.state.paidHitPopupMessage}
                        buttonText="Okay!"
                        onButtonClick={this.handleOnRequestClosePaidHitPopup}
                        onRequestClose={this.handleOnRequestClosePaidHitPopup}
                        data-testid="modal.club-profile.paid-hit-confirmation"
                    />
                )}

                {this.state.showPaidHitAvailabilityPopup && (
                    <PaidHitAvailabilityPopup
                        title="Request Paid Hit"
                        subtitle={this.state.paidHitPopupMessage}
                        paidHitAvailability={headOrganizer?.data?.paidHitAvailability}
                        isSendingPaidHitRequest={this.state.isSendingPaidHitRequest}
                        onSendClick={this.handleRequestPaidHitSubmit}
                        onCloseClick={() => {
                            this.setState({ showPaidHitAvailabilityPopup: false });
                        }}
                        data-testid="modal.club-profile.paid-hit-availability"
                    />
                )}
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setClubId: (clubId) => {
            dispatch(actions.setClubId(clubId, true));
        },
        getClubSchoolDetails: (useRostersApi) => {
            dispatch(actions.getClubSchoolDetails(useRostersApi));
        },
        getClubTMSEventsList: (initialFetch, hsEventType, start, count, includeUnpublishedEvents) => {
            dispatch(actions.getClubEventsList(initialFetch, hsEventType, start, count, includeUnpublishedEvents));
        },
        getClubDraftEventsList: (initialFetch, hsEventType, start, count) => {
            dispatch(actions.getClubDraftEventsList(initialFetch, hsEventType, start, count));
        },
        getClubResults: (initialFetch) => {
            dispatch(actions.getClubResults(initialFetch));
        },
        getOrganizerProfile: (playerId) => dispatch(setPlayerId(playerId, false)),
        updateMemberRole: (memberId, memberRole) => {
            dispatch(actions.updateMemberRole(memberId, memberRole));
        },
        updateMemberType: (memberId, isPhysicalMember) => {
            dispatch(actions.updateMemberType(memberId, isPhysicalMember));
        },
        updateClubMemberPower: (memberId, isPhysicalMember) => {
            dispatch(actions.updateClubMemberPower(memberId, isPhysicalMember));
        },
        clearSplashProps: () => {
            dispatch(actions.clearSplashProps());
        },
        uploadPhoto: (file) => dispatch(uploadTempPhoto(file)),
        clearTempPhoto: (usePng) => dispatch(clearTempPhoto(usePng)),
        cropClubBanner: (clubId, values) => dispatch(actions.cropClubBanner(clubId, values)),
        removeBannerPhoto: (clubId) => dispatch(actions.removeBannerPhoto(clubId)),
        requestToJoin: () => {
            dispatch(actions.requestToJoin());
        },
        requestToUnfollow: () => {
            dispatch(actions.requestToUnfollow());
        },
        approveOrRejectRequest: (value, member) => {
            dispatch(actions.approveOrRejectRequest(value, member));
        },
        cropClubSponsorLogo: (clubId, values) => dispatch(actions.cropClubSponsorLogo(clubId, values)),
        removeSponsorLogo: (clubId) => dispatch(actions.removeSponsorLogo(clubId)),
        resendInvite: (value, clubId, invite) => {
            dispatch(actions.resendInvite(value, clubId, invite));
        },
        deleteInvite: (value, clubId, invite) => {
            dispatch(actions.deleteInvite(value, clubId, invite));
        },
        showLoginPopUp: (data) => dispatch(loginPopUpActions.showLoginPopUp(data)),
        validateReferral: (data) => dispatch(validateReferral(data)),
        fetchPaidHitClubPaymentAccounts: (clubId) => dispatch(fetchPaidHitClubPaymentAccounts(clubId)),
        addPlayerToRoster: (playerData, checkGate, featureGates) => dispatch(actions.addPlayerToRoster(playerData, checkGate, featureGates)),
        updatePlayer: (playerData, checkGate, featureGates) => dispatch(actions.updatePlayer(playerData, checkGate, featureGates)),
        removePlayerFromRoster: (playerId, checkGate, featureGates) => dispatch(actions.removePlayerFromRoster(playerId, checkGate, featureGates)),
        setPlayerRedshirtStatus: (playerData, checkGate, featureGates) => dispatch(actions.setPlayerRedshirtStatus(playerData, checkGate, featureGates)),
        cropClubProfilePhoto: (clubId, values) => dispatch(actions.cropClubProfilePhoto(clubId, values)),
        removeClubProfilePhoto: (clubId) => dispatch(actions.removeProfilePhoto(clubId)),
        changeResultsType: (resultsType) => {
            dispatch(actions.changeResultsType(resultsType));
        },
        showError: (msg) => dispatch(showErrorPopup({ error: msg })),
        showErrorPopup: (data) => dispatch(showErrorPopup(data)),
        msgAddRecipient: (member) => dispatch(messagingActions.addRecepient({ member })),
        msgSetNewConv: (member) => dispatch(messagingActions.setNewConv({ member })),
        closePowerPopup: () => dispatch(messagingActions.closePowerPopup()),
        sendMessageToMembers: (message, clubId) => {
            dispatch(actions.sendMessageToMembers(message.replace(/(?:\r\n|\r|\n)/g, '<br>'), clubId));
        },
        inviteMembersToClub: (members) => dispatch(actions.inviteMembersToClub(members)),
        getPower6Stats: ({ conferenceId, gender }) => dispatch(actions.getPower6Stats({ conferenceId, gender })),
        getHighSchoolStandingsSeasons: ({ clubId }) => dispatch(actions.getHighSchoolStandingsSeasons({ clubId })),
        getHighSchoolStandings: ({ clubId, seasonYear }) => dispatch(actions.getHighSchoolStandings({ clubId, seasonYear })),
        includeInHighSchoolStandings: (eventId) => {
            dispatch(eventActions.includeInHighSchoolStandings(eventId));
        },
        omitFromHighSchoolStandings: (eventId) => {
            dispatch(eventActions.omitFromHighSchoolStandings(eventId));
        },
    };
}

function mapStateToProps({ auth, search, header, club, profile, uploads, coreUI, componentConfig }) {
    return { auth, search, header, club, profile, uploads, coreUI, componentConfig };
}

ClubProfilePage.propTypes = {
    club: PropTypes.shape({
        clubId: PropTypes.string.isRequired,
        clubDetails: PropTypes.shape({
            id: PropTypes.string,
            name: PropTypes.string,
            description: PropTypes.string,
            statusType: PropTypes.shape({
                value: PropTypes.string,
            }),
            tierType: PropTypes.shape({
                id: PropTypes.string,
                name: PropTypes.string,
                isCollege: PropTypes.bool,
                isHighSchool: PropTypes.bool,
                isTournamentClub: PropTypes.bool,
                isPersonalClub: PropTypes.bool,
                canPostScores: PropTypes.bool,
                canRunEvents: PropTypes.bool,
            }),
            clubHasSchool: PropTypes.bool,
            isEnterprise: PropTypes.bool,
            isPro: PropTypes.bool,
            isPremium: PropTypes.bool,
            isFreeCollege: PropTypes.bool,
            isFreeSchool: PropTypes.bool,
            isTournamentClub: PropTypes.bool,
            currentMember: PropTypes.shape({
                role: PropTypes.string,
            }),
            clubOrganizers: PropTypes.arrayOf(PropTypes.shape({})),
            clubType: PropTypes.shape({
                label: PropTypes.string,
            }),
            referralCode: PropTypes.string,
            referrerBonus: PropTypes.shape({
                amount: PropTypes.number,
            }),
            refereeBonus: PropTypes.shape({
                amount: PropTypes.number,
            }),
            clubPromoCreditBalance: PropTypes.shape({}),
            allowOffPlatformPayments: PropTypes.bool,
            demoEventCount: PropTypes.number,
            tmsEvents: PropTypes.arrayOf(PropTypes.shape({})),
            private: PropTypes.bool,
            isSpecial: PropTypes.bool,
            canHaveMultipleAdmins: PropTypes.bool,
            availableMemberSlots: PropTypes.number,
            clubSubType: PropTypes.shape({
                id: PropTypes.number,
            }),
        }),
        name: PropTypes.string,
        isLoading: PropTypes.bool,
        isSaving: PropTypes.bool,
        isClubCreated: PropTypes.bool,
        isClubUpdated: PropTypes.bool,
        membersInvited: PropTypes.bool,
        addedAdmins: PropTypes.bool,
        clubTeamRatings: PropTypes.shape({}),
        schoolDetails: PropTypes.shape({}),
        schoolDetailsState: PropTypes.shape({}),
        tmsEventsFetchState: PropTypes.shape({}),
        clubMembersFetchState: PropTypes.shape({}),
        resultsFetchState: PropTypes.shape({}),
        power6Stats: PropTypes.shape({}),
        power6StatsState: PropTypes.shape({}),
        highSchoolStandingsSeasons: PropTypes.arrayOf(PropTypes.shape({})),
        highSchoolStandings: PropTypes.shape({}),
        highSchoolStandingsState: PropTypes.shape({}),
        resultsType: PropTypes.string,
        results: PropTypes.arrayOf(PropTypes.shape({})),
    }).isRequired,
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
        replace: PropTypes.func.isRequired,
        location: PropTypes.shape({
            search: PropTypes.string,
            state: PropTypes.shape({}),
        }).isRequired,
    }).isRequired,
    auth: PropTypes.shape({
        user: PropTypes.shape({
            id: PropTypes.string,
            firstName: PropTypes.string,
            lastName: PropTypes.string,
            isPowered: PropTypes.bool,
            isProClubHeadOrganizer: PropTypes.bool,
            isAdmin: PropTypes.bool,
            memberPromoCreditBalance: PropTypes.shape({
                currency: PropTypes.shape({
                    symbol: PropTypes.string,
                }),
                balance: PropTypes.number,
            }),
        }),
        paidHitClubPaymentAccounts: PropTypes.arrayOf(PropTypes.shape({
        })),
        paidHitClubPaymentAccountsLoaded: PropTypes.bool,
    }).isRequired,
    location: PropTypes.shape({
        search: PropTypes.string.isRequired,
    }).isRequired,
    match: PropTypes.shape({
        params: PropTypes.shape({
            clubId: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
    clubType: PropTypes.string.isRequired,
    profile: PropTypes.shape({
        isLoading: PropTypes.bool,
        data: PropTypes.shape({
            id: PropTypes.string,
            displayName: PropTypes.string,
            isPaidHitter: PropTypes.bool,
            paidHitAvailability: PropTypes.shape({}),
        }),
        ptsRankings: PropTypes.shape({
            rankings: PropTypes.arrayOf(PropTypes.shape({})),
        }),
    }).isRequired,
    coreUI: PropTypes.shape({
        types: PropTypes.shape({
            messagingConversationContextType: PropTypes.arrayOf(PropTypes.shape({})),
            clubMemberRole: PropTypes.arrayOf(PropTypes.shape({})),
        }),
    }).isRequired,
    componentConfig: PropTypes.shape({
        'club-profile': PropTypes.shape({}),
    }).isRequired,
    uploads: PropTypes.shape({
        tempPhotoUrl: PropTypes.string,
    }).isRequired,
    checkGate: PropTypes.func.isRequired,
    featureGates: PropTypes.shape({
        DIRECT_ADD_CLUB_MEMBERS: PropTypes.string,
        REFERRAL_SYSTEM: PropTypes.string,
        COLLEGE_DUAL_MATCH: PropTypes.string,
    }).isRequired,
    getClubTMSEventsList: PropTypes.func.isRequired,
    getClubDraftEventsList: PropTypes.func.isRequired,
    getClubResults: PropTypes.func.isRequired,
    getOrganizerProfile: PropTypes.func.isRequired,
    updateMemberRole: PropTypes.func.isRequired,
    updateMemberType: PropTypes.func.isRequired,
    updateClubMemberPower: PropTypes.func.isRequired,
    clearSplashProps: PropTypes.func.isRequired,
    uploadPhoto: PropTypes.func.isRequired,
    clearTempPhoto: PropTypes.func.isRequired,
    cropClubBanner: PropTypes.func.isRequired,
    removeBannerPhoto: PropTypes.func.isRequired,
    requestToJoin: PropTypes.func.isRequired,
    requestToUnfollow: PropTypes.func.isRequired,
    approveOrRejectRequest: PropTypes.func.isRequired,
    cropClubSponsorLogo: PropTypes.func.isRequired,
    removeSponsorLogo: PropTypes.func.isRequired,
    resendInvite: PropTypes.func.isRequired,
    deleteInvite: PropTypes.func.isRequired,
    showLoginPopUp: PropTypes.func.isRequired,
    validateReferral: PropTypes.func.isRequired,
    addPlayerToRoster: PropTypes.func.isRequired,
    updatePlayer: PropTypes.func.isRequired,
    removePlayerFromRoster: PropTypes.func.isRequired,
    setPlayerRedshirtStatus: PropTypes.func.isRequired,
    cropClubProfilePhoto: PropTypes.func.isRequired,
    removeClubProfilePhoto: PropTypes.func.isRequired,
    changeResultsType: PropTypes.func.isRequired,
    showError: PropTypes.func.isRequired,
    showErrorPopup: PropTypes.func.isRequired,
    // eslint-disable-next-line react/no-unused-prop-types
    msgAddRecepient: PropTypes.func.isRequired,
    msgSetNewConv: PropTypes.func.isRequired,
    sendMessageToMembers: PropTypes.func.isRequired,
    inviteMembersToClub: PropTypes.func.isRequired,
    getPower6Stats: PropTypes.func.isRequired,
    getHighSchoolStandingsSeasons: PropTypes.func.isRequired,
    getHighSchoolStandings: PropTypes.func.isRequired,
    includeInHighSchoolStandings: PropTypes.func.isRequired,
    omitFromHighSchoolStandings: PropTypes.func.isRequired,
    fetchPaidHitClubPaymentAccounts: PropTypes.func.isRequired,
};

export default withRouter(withStatsig(connect(mapStateToProps, mapDispatchToProps)(ClubProfilePage)));
